export * from './edit.component';
export * from './edit.service';


// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/edit/index.ts